import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CoordinatorCompanyComponent } from './components/coordinator-company/coordinator-company.component';
import { CoordinatorDoctorComponent } from './components/coordinator-doctor/coordinator-doctor.component';
import { CoordinatorStatisticsComponent } from './components/coordinator-statistics/coordinator-statistics.component';
import { FuseSharedModule } from '@fuse/shared.module';
import { FuseHighlightModule, FuseShortcutsModule, FuseWidgetModule } from '@fuse/components';
import { RouterModule } from '@angular/router';
import { AngularMaterialModule } from 'app/angular-material.module';
import { SharedModule } from '../common/shared.module';
import { CoordinatorComponent } from './coordinator.component';
import { AddEditVisitaEmpresaComponent } from './components/coordinator-company/add-edit-visita-empresa/add-edit-visita-empresa.component';
import { YearToggleComponent } from './components/common/year-toggle/year-toggle.component';
import { AddEditDoctorVisitComponent } from './components/coordinator-doctor/add-edit-doctor-visit/add-edit-doctor-visit.component';
import { AbsenteeismChartComponent } from './components/coordinator-statistics/absenteeism-chart/absenteeism-chart.component';
import { BaseChartDirective  } from 'ng2-charts';
import { KpiGridComponent } from './components/coordinator-statistics/kpi-grid/kpi-grid.component';
import { ContactsComponent } from './components/coordinator-statistics/contacts/contacts.component';
import { CompanyCommentsComponent } from './components/coordinator-statistics/company-comments/company-comments.component';
import { ChartPopupComponent } from './components/coordinator-statistics/chart-popup/chart-popup.component';
import { CommentPopupComponent } from './components/coordinator-statistics/company-comments/comment-popup/comment-popup.component';
import {CarouselModule} from 'primeng/carousel';
import {ButtonModule} from 'primeng/button'; 
import {ToastModule} from 'primeng/toast';
import { AsistentesPopupComponent } from './components/coordinator-company/asistentes-popup/asistentes-popup.component';
@NgModule({
    declarations: [
        CoordinatorComponent,
        CoordinatorCompanyComponent,
        CoordinatorDoctorComponent,
        CoordinatorStatisticsComponent,
        AddEditVisitaEmpresaComponent,
        YearToggleComponent,
        AddEditDoctorVisitComponent,
        AbsenteeismChartComponent,
        KpiGridComponent,
        ContactsComponent,
        CompanyCommentsComponent,
        ChartPopupComponent,
        CommentPopupComponent, AsistentesPopupComponent
    ],
    imports: [
        CommonModule,
        RouterModule,
        FuseSharedModule,
        FuseHighlightModule,
        FuseWidgetModule,
        AngularMaterialModule,
        SharedModule,
        FuseShortcutsModule,
        BaseChartDirective ,
        CarouselModule,
        ButtonModule,
        ToastModule,
    ]
})
export class CoordinatorModule { }
